import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';
import {
  getBrandingImage,
  getBrandingColor,
  imageTypes,
  colorTypes,
} from 'src/branding';
import { company } from 'src/config';

const LoadingContainer = styled.div`
  position: relative;
  flex: 0 0 auto;
  display: block;
  font-size: ${({ size }) => size};
  height: 1em;
  min-height: 1em;
  max-height: 1em;
  ${({ withText }) => (withText
  ? css`
          width: 3em;
          min-width: 3em;
          max-width: 3em;
        `
  : css`
          width: 1em;
          min-width: 1em;
          max-width: 1em;
        `)}
  margin: auto;
  overflow: visible;
  align-self: center;
  justify-self: center;
`;

const AnimatedLogo = styled.img`
  display: block;
  position: absolute;
  width: 1em;
  height: 1em;
  bottom: 0;

  animation: bounce 500ms alternate infinite ease;

  @keyframes bounce {
    0% {
      bottom: 0;
      height: 0.9em;
      transform: scaleX(1.65);
    }
    35% {
      height: 1em;
      transform: scaleX(1);
    }
    100% {
      bottom: 1.2em;
    }
  }
`;

const LoaderText = styled.div`
  position: absolute;
  color: ${getBrandingColor(colorTypes.loadingIndicatorTxt)};
  font-size: 0.3em;
  font-weight: 600;
  white-space: nowrap;
  right: 0;
  bottom: 0;
  line-height: 3.333em;
`;

const LoadingIndicatorMidtnorge = () => (
  <div
    className="ispinner ispinner-large"
    style={{ position: 'relative', top: '0.23em', left: '0.4em' }}
  >
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
    <div className="ispinner-blade" />
  </div>
);

const LoadingIndicatorFuruseth = () => (
  <AnimatedLogo
    src={getBrandingImage(imageTypes.slaktewebLogoSmall)}
  />
);

const LoadingIndicator = ({
  withText,
  customTxt,
  size,
  txtStyle = {},
  ...props
}) => (
  <LoadingContainer {...props} withText={withText} size={size}>
    {company === 'furuseth' && (
      <LoadingIndicatorFuruseth />
    )}
    {company === 'midtnorge' && (
      <LoadingIndicatorMidtnorge />
    )}
    {withText && (
      <LoaderText style={{ ...txtStyle }}>
        {customTxt || 'Laster inn...'}
      </LoaderText>
    )}
  </LoadingContainer>
);

LoadingIndicator.propTypes = {
  withText: PropTypes.bool,
  size: PropTypes.string,
};

LoadingIndicator.defaultProps = {
  withText: false,
  size: '5rem',
};

export default LoadingIndicator;
